import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFocalPoint24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconFocalPoint24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.75 4.5c-.69 0-1.25.56-1.25 1.25v3.182a.75.75 0 1 1-1.5 0V5.75A2.75 2.75 0 0 1 5.75 3h3.182a.75.75 0 1 1 0 1.5zM19.5 8.932V5.75c0-.69-.56-1.25-1.25-1.25h-3.182a.75.75 0 1 1 0-1.5h3.182A2.75 2.75 0 0 1 21 5.75v3.182a.75.75 0 0 1-1.5 0M18.25 19.5h-3.182a.75.75 0 1 0 0 1.5h3.182A2.75 2.75 0 0 0 21 18.25v-3.182a.75.75 0 0 0-1.5 0v3.182c0 .69-.56 1.25-1.25 1.25M4.5 18.25c0 .69.56 1.25 1.25 1.25h3.182a.75.75 0 0 1 0 1.5H5.75A2.75 2.75 0 0 1 3 18.25v-3.182a.75.75 0 0 1 1.5 0zM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFocalPoint24);
